// extracted by mini-css-extract-plugin
export var input = "selectBox-module--input--BIxmp";
export var inputWrapper = "selectBox-module--inputWrapper--NsB3f";
export var title = "selectBox-module--title--XEXI2";